
export default class homepageAlert
{
    constructor()
    {
        this.el = '#alert';

        if (!$(this.el).length) {
            return;
        }

        this.data = {
            active: false,
        };

        this._initVue();
    }

    _initVue()
    {
        let homepageAlertInst = new Vue({
            el: this.el,
            data: this.data,
            methods: {
                dismiss() {
                    this.active = false;
                    this.setCookie('alertDismissed', 'true', 1);
                },

                setCookie(name, value, days) {
                    let expires = null;
                    let date = new Date();

                    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                    expires = '; expires=' + date.toUTCString();

                    document.cookie = name + '=' + (value || '') + expires + '; path=/';
                },

                getCookie(name) {
                    return document.cookie.split(';').filter(cookie => cookie.includes(name))[0];
                },
            },
            mounted() {
                $(window).load(() => {
                    this.active = !this.getCookie('alertDismissed');
                });
            },
        });
    }
}
